import { CardMedia, Grid, Typography } from "@mui/material";
import clsx from "clsx";
import React, { memo } from "react";
import { isMobile } from "react-device-detect";
const HeaderRight = (props) => {
  const { title, isQuestions, ndid } = props;
  return (
    <Grid className={clsx(isQuestions ? "box-header-q" : "box-header")}>
      {isQuestions && (
        <Grid sx={{ paddingTop: isMobile ? "10%" : "0" }}>
          <CardMedia
            component="img"
            className="img-dialog"
            image={"../../../images/เตรียมพร้อมก่อนเปิดบัญชี.png"}
            sx={{ width: 100 }}
            alt="warning"
          />
        </Grid>
      )}
      {isQuestions && isMobile ? (
        ""
      ) : (
        <Grid className={clsx(isQuestions ? "pt-4" : "pt-2")}>
          <Typography
            className={clsx("box-title font-24", ndid && "pt-mb")}
            sx={{ whiteSpace: "nowrap" }}
          >
            {title}
          </Typography>
        </Grid>
      )}
    </Grid>
  );
};
export default memo(HeaderRight);
